import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./index.css";

import imagebk from "../../../assets/images/back.png";
import logoutimg from "../../../assets/images/logout.png";
import BgImage from "../../../assets/images/BG1.jpg";
import SwitchImage from "../../../assets/images/switch_white.png"
import ITproductsImg from "../../../assets/images/IT.png"
import LoadingGif from "../../../assets/images/BG-switch loader_2.gif"

import { Height } from "@mui/icons-material";
import { width } from "@mui/system";
import { grey } from "@mui/material/colors";

import Products from "./Products";
import Status from "../Status/Status";
import FunctionalHead from "../Approver/FunctionalHead";
import AdminPage from "../ItHead/AdminPage";
import Issuer from "../ItIssuer/Issuer";

function Index() {

    const allowed =  localStorage.getItem('AllowSwitchGear');

    if (allowed != "Allow"){
         window.location.href = "/landingpage";
    }

    const emp_id = localStorage.getItem("empid");
    if (!emp_id) {
        window.location.href = "/login";
    }

    const emailid = localStorage.getItem("emailid").toLocaleLowerCase();

    const IThead = ['rajesh.sundaramurthy@switchmobilityev.com'];
    const itissuer = ['sathish.m@switchmobilityev.com'];

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("products");
    const [loading, setLoading] = useState(false);

    const showProducts = () => {
        setLoading(true);
        setActiveTab("products");
        setTimeout(() => {
            setLoading(false);
        }, 500);
    };
    const showStatus = () => {
        setLoading(true);
        setActiveTab("status");
        setTimeout(() => {
            setLoading(false);
        }, 500);
    };
    const showAdmin = () => {
        setLoading(true);
        setActiveTab("admin");
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }
    const showFunctionalHead = () => {
        setLoading(true);
        setActiveTab("functionalhead");
        setTimeout(() => {
            setLoading(false);
        }, 500);
    };
    const showITteam = () => {
        setLoading(true);
        setActiveTab("itteam");
        setTimeout(() => {
            setLoading(false);
        }, 500);
    };


    const redirectTodashboard = () => {
        navigate("/landingPage");
    };

    const redirectToLogin = () => {
        navigate("/login");
    };

    // STATUS 

    const [activeStatusTab, setActiveStatusTab] = useState("userrequestedproducts");

    const UserRequestedProducts = () => {
        setActiveStatusTab("userrequestedproducts")
    };
    const UserGrantedProducts = () => {
        setActiveStatusTab("usergrantedproducts")
    };

    // FUNCTIONAL HEAD 

    const [activeFunctionalHeadTab, setActiveFunctionalHeadTab] = useState("functionalheadrequestedproducts");

    const FunctionalRequestedProducts = () => {
        setActiveFunctionalHeadTab("functionalheadrequestedproducts");
    };
    const FunctionalGrantedProducts = () => {
        setActiveFunctionalHeadTab("functionalheadgrantedproducts");
    };

    // ADMIN

     const [activeAdminTab, setActiveAdminTab] = useState("addproducts");
    
        const AdminAddProducts = () => {
            setActiveAdminTab("addproducts")
        };
        const AdminUpdateProducts = () => {
            setActiveAdminTab("updateproducts")
        };
        const AdminDeleteProducts = () => {
            setActiveAdminTab("deleteproducts")
        };
        const AdminListProducts = () => {
            setActiveAdminTab("listproducts")
        };
        const AdminRequestedListProducts = () => {
            setActiveAdminTab("requestedlistproducts")
        };
        const AdminGrantedListProducts = () => {
            setActiveAdminTab("grantedlistproducts")
        };

        // IT ISSUER 

        const [activeIssuerTab, setActiveIssuerTab] = useState("issuerrequestedproducts");

    const IssuerRequestedProducts = () => {
        setActiveIssuerTab("issuerrequestedproducts")
    };
    const IssuerGrantedProducts = () => {
        setActiveIssuerTab("issuergrantedproducts")
    };

        const glassTab = {
    background: "linear-gradient(145deg, rgba(255,255,255,0.25), rgba(255,255,255,0.08))",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    border: "1px solid rgba(255,255,255,0.3)",
    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
    borderRadius: "25px",
    color: "white"
};


    return (

        <>

            <div style={{
                backgroundImage: `url(${BgImage})`,
                minHeight: "100vh",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}>

                <div style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    backdropFilter: "blur(6px)",
                    backgroundImage: `url(${BgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>



                    {/*  HEADER  */}

                    <div className="d-flex flex-row justify-content-between align-items-center  p-2"

                    >

                        <div>
                            <img
                                src={imagebk}
                                className="rounded"
                                style={{ width: "30px", height: "30px", cursor: "pointer", filter: "invert(1)" }}
                                onClick={redirectTodashboard}
                            />
                        </div>

                        <div>
                            <img
                                src={SwitchImage}
                                className="img-fluid"
                                style={{
                                    maxWidth: "120px",
                                    height: "auto", cursor: "pointer"
                                }}

                            />
                        </div>

                        <div>
                            <img
                                src={logoutimg}
                                className="rounded"
                                style={{
                                    width: "30px", height: "30px", cursor: "pointer", transform: "rotate(90deg)", filter: "invert(1)"
                                }}
                                onClick={redirectToLogin}
                            />
                        </div>

                    </div>


                    {/* NAVBARS */}

                    <div className="d-flex justify-content-center px-2 mb-1">

                        <div style={{ width: "100%", maxWidth: "600px" }}>

                            <ul
                                className="nav nav-pills gap-2 small bg-primary rounded-5 shadow-sm m-0"
                                id="pillNav2"
                                role="tablist"
                                style={{
                                    "--bs-nav-link-color": "var(--bs-white)",
                                    "--bs-nav-pills-link-active-color": "var(--bs-primary)",
                                    "--bs-nav-pills-link-active-bg": "var(--bs-white)"
                                }}
                            >

                                <li className="nav-item flex-fill">
                                    <button
                                        className={`nav-link rounded-5 fw-bold w-100 ${activeTab === "products" ? "active" : ""}`}
                                        onClick={showProducts}
                                    >
                                        PRODUCTS
                                    </button>
                                </li>

                                <li className="nav-item flex-fill">
                                    <button
                                        className={`nav-link rounded-5 fw-bold w-100 ${activeTab === "status" ? "active" : ""}`}
                                        onClick={showStatus}
                                    >
                                        STATUS
                                    </button>
                                </li>


                                <li className="nav-item flex-fill">
                                    <button
                                        className={`nav-link rounded-5 fw-bold w-100 ${activeTab === "functionalhead" ? "active" : ""}`}
                                        onClick={showFunctionalHead}
                                    >
                                        APPROVER
                                    </button>
                                </li> 


                                {IThead.includes(emailid) ? <li className="nav-item flex-fill">
                                    <button
                                        className={`nav-link rounded-5 fw-bold w-100 ${activeTab === "admin" ? "active" : ""}`}
                                        onClick={showAdmin}
                                    >
                                        ADMIN
                                    </button>
                                </li> : null}


                                {itissuer.includes(emailid) ? <li className="nav-item flex-fill">
                                    <button
                                        className={`nav-link rounded-5 fw-bold w-100 ${activeTab === "itteam" ? "active" : ""}`}
                                        onClick={showITteam}
                                    >
                                        IT ISSUER
                                    </button>
                                </li> : null}



                            </ul>

                        </div>

                    </div>

                    


                    {/* STATUS */}

                    {activeTab === "status" &&
                    <div>
                        <ul className="nav nav-pills mb-1" style={{ borderRadius: "5px" }} >

                            <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                    style={
    activeStatusTab === "userrequestedproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={UserRequestedProducts}
                                >
                                    REQUESTED PRODUCTS
                                </button>
                            </li>

                            <li className="nav-item" style={{ borderRadius: "5px" }}>
                                <button
                                    className="nav-link fw-bold border-0"
                                     style={
    activeStatusTab === "usergrantedproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={UserGrantedProducts}
                                >
                                    MY PRODUCTS
                                </button>
                            </li>

                        </ul>
                    </div>
                }

                {/* APPROVER */}

                    {activeTab === "functionalhead" &&
                    <div>
                        <ul className="nav nav-pills mb-1" style={{ borderRadius: "5px" }} >

                            <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                    style={
    activeFunctionalHeadTab === "functionalheadrequestedproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={FunctionalRequestedProducts}
                                >
                                    REQUESTED PRODUCTS
                                </button>
                            </li>

                            <li className="nav-item" style={{ borderRadius: "5px" }}>
                                <button
                                    className="nav-link fw-bold border-0"
                                     style={
    activeFunctionalHeadTab === "functionalheadgrantedproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={FunctionalGrantedProducts}
                                >
                                    GRANTED PRODUCTS
                                </button>
                            </li>

                        </ul>
                    </div>
                }



                {/* ADMIN */}

                    {activeTab === "admin" &&
                    <div>
                        <ul className="nav nav-pills mb-1" style={{ borderRadius: "5px" }} >

                            <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                   style={
    activeAdminTab === "addproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={AdminAddProducts}
                                >
                                    ADD PRODUCTS
                                </button>
                            </li>

                             <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                    style={
    activeAdminTab === "updateproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={AdminUpdateProducts}
                                >
                                    UPDATE PRODUCTS
                                </button>
                            </li>

                             <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                    style={
    activeAdminTab === "deleteproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={AdminDeleteProducts}
                                >
                                    DELETE PRODUCTS
                                </button>
                            </li>

                             <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                     style={
    activeAdminTab === "listproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={AdminListProducts}
                                >
                                    LIST PRODUCTS
                                </button>
                            </li>

                              <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                     style={
    activeAdminTab === "requestedlistproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={AdminRequestedListProducts}
                                >
                                    REQUESTED PRODUCTS
                                </button>
                            </li>

                             <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                    style={
    activeAdminTab === "grantedlistproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={AdminGrantedListProducts}
                                >
                                    GRANTED PRODUCTS
                                </button>
                            </li>



                          
                        </ul>
                    </div>
                }


                  {/* IT ISSUER */}

                    {activeTab === "itteam" &&
                    <div>
                        <ul className="nav nav-pills mb-1" style={{ borderRadius: "5px" }} >

                            <li className="nav-item" >
                                <button
                                    className="nav-link fw-bold border-0"
                                    style={
    activeIssuerTab === "issuerrequestedproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={IssuerRequestedProducts}
                                >
                                    REQUESTED PRODUCTS
                                </button>
                            </li>

                            <li className="nav-item" style={{ borderRadius: "5px" }}>
                                <button
                                    className="nav-link fw-bold border-0"
                                     style={
    activeIssuerTab === "issuergrantedproducts"
        ? {
              backgroundColor: "white",
              color: "blue",
              borderRadius: "25px"
          }
        : glassTab
}
                                    onClick={IssuerGrantedProducts}
                                >
                                    GRANTED PRODUCTS
                                </button>
                            </li>

                        </ul>
                    </div>
                }




                </div>

                {/* ********************************************************************* */}
                {/* CONTENTS */}

                <div style={{ zIndex: "999" }}>




                    {/* PRODUCTS TAB */}

                    {activeTab === "products" && <div className="fade-container">
                        <Products  setParentLoading={setLoading} />
                    </div>
                    }

                    {/* STATUS TAB */}


                    {activeTab === "status" && <Status setParentLoading={setLoading} activeStatusTab={activeStatusTab} />}

                    {/* FUNCTIONAL HEAD TAB */}

                    {activeTab === "functionalhead" && <FunctionalHead setParentLoading={setLoading} activeFunctionalHeadTab={activeFunctionalHeadTab} />}

                    {/* ADMIN TAB */}

                    {activeTab === "admin" && <AdminPage setParentLoading={setLoading} activeAdminTab={activeAdminTab} />}

                    {/* IT TAB */}

                    {activeTab === "itteam" && <Issuer setParentLoading={setLoading} activeIssuerTab={activeIssuerTab} />}



                </div>




            </div>

            {loading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        height: "100vh",
                        width: "100vw",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    <img
                        src={LoadingGif}
                        alt="Loading"
                        style={{ width: "120px", height: "120px" }}
                    />
                </div>
            )}

        </>
    )
}

export default Index;